import * as R from "ramda"
export default {
  isInMSDK: context => context.userAgent.msdk,
  IsInQQOrWechat: context => context.userAgent.weixin || context.userAgent.QQ,
  showLoginPrompt: context => {
    return !context.userAgent.weixin && !context.userAgent.QQ && !context.userAgent.msdk
  },
  showWelcome: context => {
    // return true
    return context.userAgent.weixin || context.userAgent.QQ || context.userAgent.msdk
  },
  hasRegisteredTask: (context, event) => event.data.task_token,
  unregisteredTask: (context, event) => !event.data.task_token,
  hasSelectedRole: context => {
    return context.selectedRole && context.selectedRole.name
  },
  //是否达成了任务门槛
  hasnotReachedScore: (context, event) => {
    return +context.taskInfo.total_score < +event.present_rank
  },
  //未领过任务奖励
  hasnotReceivedtaskAward: (context, event) => {
    const ranks = context.taskInfo.present_rank.split(",")
    return !ranks.includes(event.present_rank.toString())
  },
  //查到过抽奖奖品用户再次点击
  hasFetchedDrawAward: (context, event) => context.award && context.award[event.present_rank],
  //领过任务奖励同时没有抽奖券已经抽过奖了
  hasDrawCoupons: (context, event) => event.data && event.data.length > 0,
  notReachScore: context => {
    const score = +context.taskInfo.total_score
    let rank = +context.selectedPresentRank
    if (rank == 7) {
      rank = 6
    }
    return score < rank
  },
  notReachFinalAward: context => {
    let rank = +context.selectedPresentRank
    if (rank == 7) {
      return true
    } else {
      return false
    }
  },
  isActivityEnd: (context, event) => {
    return (event.data.ret && event.data.ret == 1414) || +new Date() >= new Date(context.gameConfig.end_time)
  },

  /**
   * 如果用户最多30分，那么到了30分的时候就不能买1积分和6积分的物品，大于等于25分的时候就不让买6积分物品
   * @param context
   * @param event
   * @returns {boolean}
   */
  forbiddenBuy: (context, event) => {
    return +context.taskInfo.total_score >= +event.buy_limits_score
  },
  isnotInWechatOrQQ: context => {
    return !context.userAgent.weixin && !context.userAgent.QQ
  },

  enterNewRound: context => {
    const score = +context.taskInfo.total_score + 1
    //用户购买到第一个物品包括循环的时候显示进入新轮
    if (score % 6 == 1) {
      return true
    } else {
      return false
    }
  },

  isSixthBoxDrawSuccess: context => {
    return context.selectedPresentRank == 6
  },

  hasTaskProgress: (context, event) => {
    return context?.tasks[event.level]
  },
  isBatchDraw: context => {
    return context.purchaseInfo.score == 6
  },
  isBatchDrawActorExist: (context, event) => {
    const sixBoxGroupid = context.gameConfig.drawGroupid[context.selectedMap].filter(item => item.rank <= 6).map(item => item.groupid)
    return Object.keys(R.pick(sixBoxGroupid, event.data)).every(key => context?.luckLottery?.[key])
  },
  hasBatchDrawError: context => context.batchDrawError > 0,
  hasUnusedCoupon: (context, event) => {
    return Object.keys(event.data).length > 0
  },
  // 用户是否有领取免费任务的前置条件
  checkUserCanReceiveFightTask: (context, event) => {
    return event.data && event.data.precondition_check_result && event.data.precondition_check_result == 1
  },
  // 判断用户参与任务报错是因为不满足前置条件
  checkJoinTaskError: (context, event) => {
    return event.data && event.data.err_code && event.data.err_code.indexOf("1211--101") > -1
  },
  insufficientBalance: (context, event) => {
    return context.userAgent.msdk && event?.data?.ret == 1004
  },
  couponInvalid: (context, event) => event?.data?.err_code == "1132-20004403-0"
}
